module.exports = __webpack_public_path__ + "img/Folder.030cba73.svg";